import { Stack, Select, Box, SvgIcon, MenuItem, SelectChangeEvent } from '@mui/material'
import styles from './Footer.module.scss'
import classNames from 'classnames/bind'
import { locales } from '~/i18n/i18n'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ALL_NS } from '~/i18n/namespaces'
import LanguageIcon from '@mui/icons-material/Language'
import { useModal } from 'mui-modal-provider'
import { PATH_NAME } from '~/constants'
import { ClientInstallerPopup, ConfirmationPopup, EFTypography } from '~/components'
const version = require('~/version.txt')

export function Footer() {
  const { t, i18n } = useTranslation(ALL_NS)
  const { showModal } = useModal()
  const cx = classNames.bind(styles)

  const [languageSelected, setLanguageSelected] = useState(i18n.language)
  const [managerVersion, setManagerVersion] = useState('')

  const handleChangeLanguage = (e: SelectChangeEvent<string>) => {
    setLanguageSelected(e.target.value)
    i18n.changeLanguage(e.target.value)
  }

  function handleOpenInstallerPopup(event: any) {
    event.preventDefault()
    showModal(ConfirmationPopup, {
      actionType: 'Close',
      children: <ClientInstallerPopup />,
      onClose: () => {},
      title: t('PageTitle_ClientInstaller'),
      width: '450px'
    })
  }

  useEffect(() => {
    fetch(version)
      .then(response => response.text())
      .then(text => {
        setManagerVersion(text)
      })
      .catch(error => console.error('Error loading the file:', error))
  }, [])

  return (
    <Stack className={cx('footer')}>
      {window.location.pathname === PATH_NAME.LOGIN_PAGE.path && (
        <EFTypography
          color='link'
          pb={1}
          role='button'
          className={cx('item')}
          onClick={event => handleOpenInstallerPopup(event)}
        >
          {t('PageTitle_ClientInstaller')}
        </EFTypography>
      )}
      <Stack
        direction='row'
        alignItems='center'
        justifyContent='center'
      >
        {/* <div className={cx('item')}>FAQ</div> ∙ <div className={cx('item')}>Policy</div> ∙ */}
        <Select
          id='language-select'
          value={languageSelected}
          className={cx('item')}
          onChange={handleChangeLanguage}
          sx={{
            border: 'var(--border) !important',
            color: 'var(--dark)!important',
            height: '2rem',
            width: 'auto',
            lineHeight: '2.8rem',
            '&& svg': { margin: 'auto', color: 'var(--dark)!important' },
            '& .MuiSelect-select': {
              py: 0
            }
          }}
          renderValue={value => {
            return (
              <Box sx={{ display: 'flex', gap: 1 }}>
                <SvgIcon color='inherit'>
                  <LanguageIcon />
                </SvgIcon>
                {locales[value as keyof typeof locales]}
              </Box>
            )
          }}
        >
          {Object.keys(locales).map(key => (
            <MenuItem
              key={key}
              value={key}
              sx={{ color: 'var(--dark)', background: 'white !important' }}
            >
              {locales[key as keyof typeof locales]}
            </MenuItem>
          ))}
        </Select>
      </Stack>
      <p>
        {t('Message_tk0_CopyrightTaitCommunications_tk1', {
          0: `v${managerVersion}`,
          1: new Date().getFullYear()
        })}
      </p>
    </Stack>
  )
}
